import {
  TASKLIST_LOADING,
  GET_TASKLIST,
  GET_TASKLIST_SUCCESS,
  GET_TASKLIST_FAIL,
  ADD_TASKLIST_SUCCESS,
  ADD_TASKLIST_FAIL,
  DELETE_TASKLIST_SUCCESS,
  DELETE_TASKLIST_FAIL,
  UPDATE_TASKLIST_SUCCESS,
  UPDATE_TASKLIST_FAIL,
  TASKLIST_RESET
} from "./actionType";

const INIT_STATE = {
  taskLists: [],
  error: {},
};

const TaskList = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_TASKLIST_SUCCESS:
      switch (action.payload.actionType) {
        case GET_TASKLIST:
          return {
            ...state,
            taskLists: action.payload.data,
            isTaskListCreated: false,
            isTaskListSuccess: true,
            loading: false,
          };

        default:
          return { ...state };
      }
    case GET_TASKLIST_FAIL:
      switch (action.payload.actionType) {
        case GET_TASKLIST_FAIL:
          return {
            ...state,
            error: action.payload.error,
            isTaskListCreated: false,
            isTaskListSuccess: false,
            loading: false,
          };
        default:
          return { ...state };
      }

    case GET_TASKLIST: {
      return {
        ...state,
        isTaskListCreated: false,
        loading: true,
      };
    }

    case TASKLIST_LOADING: {
      return {
        ...state,
        isTaskListCreated: false,
        loading: true,
      };
    }

    case ADD_TASKLIST_SUCCESS:
      return {
        ...state,
        isTaskListCreated: true,
        loading: false,
        taskLists: [action.payload.data, ...state.taskLists],
      };

    case ADD_TASKLIST_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DELETE_TASKLIST_SUCCESS:
      return {
        ...state,
        loading: false,
        isTaskListCreated: true,
        taskLists: state.taskLists.filter(
          taskList => taskList.id.toString() !== action.payload.id.toString()
        ),
      };

    case DELETE_TASKLIST_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_TASKLIST_SUCCESS:
      return {
        ...state,
        loading: false,
        isTaskListCreated: true,
        taskLists: state.taskLists.map(taskList =>
          taskList.id.toString() === action.payload.data.id.toString() ? { ...taskList, ...action.payload.data } : taskList
        ),
      };

    case UPDATE_TASKLIST_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case TASKLIST_RESET:
      return INIT_STATE;

    default:
      return { ...state };
  }
};

export default TaskList;